import React from 'react'

function AppServicesDetails() {
  return (
    <div>
      <div className="services-details-area default-padding">
        <div className="cotnainer">
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <div className="site-heading text-center">
                <h4 className="sub-title">Social Media Marketing</h4>
                <h2 className="title">Social Media That Works, Marketing That Converts</h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="services-details-items">
            <div className="row">
              <div className="col-xl-12 services-single-content">
                <div className="thumb mb-50">
                  <img src="static/img/mobile/21.jpg" alt="Thumb" />
                </div>
                <p>
                  In this digital world, social media is vital for brand engagement and Microcode Software has a great reputation for social media marketing. As one of the top social media marketing agencies, we grow online visibility, enhance brand awareness and provide meaningful engagement for your business. With experts in content creation, social media strategists and data analysts, we can develop a custom campaign for your audience. We keep your brand trending and up to date, whatever the platform, be it Facebook, LinkedIn, Instagram or Twitter.
                </p>
                <div className="process-style-one-items mt-50">
                  <div className="choose-us-one-thumb">
                    <div className="content">
                      <div className="left-info">
                        <h2 className="title">
                          Fuel Your Brand from Strategy to Success
                        </h2>
                      </div>
                      <div className="process-style-one">
                        <div className="process-style-one-item">
                          <span>01</span>
                          <h4>Strategy Planning</h4>
                          <p>
                            Determine goals, audience, platforms and content strategy.
                          </p>
                        </div>
                        <div className="process-style-one-item">
                          <span>02</span>
                          <h4>Content Creation</h4>
                          <p>
                            Create graphics and write captions for your brand according to the strategy.
                          </p>
                        </div>
                        <div className="process-style-one-item">
                          <span>03</span>
                          <h4>Scheduling & Posting</h4>
                          <p>
                            Use programs to schedule the best times to post and check that all elements of the post are ready for publication.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default AppServicesDetails
